import { render, staticRenderFns } from "./goodsInfo.vue?vue&type=template&id=61d9ec5b&scoped=true&"
import script from "./goodsInfo.vue?vue&type=script&lang=js&"
export * from "./goodsInfo.vue?vue&type=script&lang=js&"
import style0 from "./goodsInfo.vue?vue&type=style&index=0&id=61d9ec5b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d9ec5b",
  null
  
)

export default component.exports